/**
 * Returns client height of the element.
 *
 * @param elm - An element to get height.
 */
export function height( elm: Element ): number {
  return elm.clientHeight;
}
